import { App } from 'vue';
// import AvatarCropper from 'vue-avatar-cropper';

/**
 *
 * @param {App} app
 * @constructor
 * Подключение компонент, которые могут отображаться только у клиента
 * на сервере вызывают ошибки
 */
export const RegisterClientComponent = (app) => {
  // Загрузчик-обрезчик аватара
  // app.component('AvatarCropper', AvatarCropper);
};
